import React, { FC } from 'react'
import { Badge, createStyles, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'

export interface IDedicatedLanesExpiringBadgeProps {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
}

const useDedicatedLanesExpiringBadgeStyles = makeStyles(theme =>
  createStyles<string, { marginTop?: string; marginBottom?: string; marginLeft?: string }>({
    badged: {
      background: brandColors.warning0,
      borderRadius: 44,
      color: brandColors.warning1,
      padding: '5px 12px',
      width: 102,
      height: 24,
      marginTop: ({ marginTop }) => marginTop || '9px',
      marginBottom: ({ marginBottom }) => marginBottom || '0px',
      marginLeft: ({ marginLeft }) => marginLeft || '0px',

      '& .MuiBadge-anchorOriginTopRightRectangular': {
        top: 'inherit',
        transform: 'scale(1) translate(-6px, -3px)',
        fontWeight: 700,
      },

      [theme.breakpoints.down('md')]: {
        marginTop: ({ marginTop }) => marginTop || '0px',
        marginBottom: ({ marginBottom }) => marginBottom || '0px',
        marginLeft: ({ marginLeft }) => marginLeft || '0px',
      },
    },
  })
)

export const DedicatedLanesExpiringBadge: FC<IDedicatedLanesExpiringBadgeProps> = ({
  marginBottom,
  marginLeft,
  marginTop,
}) => {
  const classes = useDedicatedLanesExpiringBadgeStyles({
    marginTop,
    marginBottom,
    marginLeft,
  })

  return <Badge className={classes.badged} invisible={false} badgeContent='Expiring Soon' />
}
